import { useQuery } from "@tanstack/react-query";
import { axios } from "@/client/libs/axios";
import { PaymentWithUserAndCoupon } from "libs/dto/src/payment";

const getPayment = async (id: string) => {
  const response = await axios.get<PaymentWithUserAndCoupon>(`/payments/${id}`);
  return response.data;
};

export const usePayment = (id: string) => {
  const {
    data: payment,
    isPending: loading,
    error,
  } = useQuery({
    queryKey: ["payment", id],
    queryFn: () => getPayment(id),
    enabled: !!id,
  });

  return { payment, loading, error };
};
